import i18n from "../i18n";
import { apiClient } from "./apiClient";

// Alarm kurallarını listele
export async function getAlarmRules(accessToken, edgeId = null) {
  const params = edgeId ? { edge_id: edgeId } : {};
  const res = await apiClient.get("/alarm-rules", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return res.data;
}

// Tek bir alarm kuralını getir
export async function getAlarmRule(accessToken, ruleId) {
  const res = await apiClient.get(`/alarm-rules/${ruleId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Yeni alarm kuralı oluştur
export async function createAlarmRule(accessToken, ruleData) {
  const res = await apiClient.post("/alarm-rules", ruleData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Alarm kuralını güncelle
export async function updateAlarmRule(accessToken, ruleId, ruleData) {
  const res = await apiClient.put(`/alarm-rules/${ruleId}`, ruleData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Alarm kuralını sil
export async function deleteAlarmRule(accessToken, ruleId) {
  const res = await apiClient.delete(`/alarm-rules/${ruleId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Alarm kuralını aktif/pasif yap
export async function toggleAlarmRule(accessToken, ruleId) {
  const res = await apiClient.post(`/alarm-rules/${ruleId}/toggle`, {}, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// `label` değerleri getter: seçili dile göre okunur (dil değişince güncel kalır).
const labelled = (group, value, rest) => ({ value, get label() { return i18n.t(`alarms.${group}.${value}`); }, ...rest });

// Koşul tipleri
export const CONDITION_TYPES = [
  labelled("condition", "GREATER_THAN", { symbol: ">", color: "var(--danger)" }),
  labelled("condition", "LESS_THAN", { symbol: "<", color: "var(--accent-navy-light)" }),
  labelled("condition", "EQUALS", { symbol: "=", color: "var(--text-muted)" }),
  labelled("condition", "BETWEEN", { symbol: "↔", color: "#a371f7" }),
];

// Aksiyon tipleri
export const ACTION_TYPES = [
  labelled("action", "EMAIL", { icon: "📧" }),
];

// Sensör alanları
export const SENSOR_FIELDS = [
  labelled("sensor", "temperature", { unit: "°C" }),
  labelled("sensor", "vibration", { unit: "mm/s" }),
  labelled("sensor", "pressure", { unit: "kPa" }),
  labelled("sensor", "voltage", { unit: "V" }),
  labelled("sensor", "current", { unit: "A" }),
];
